export default "__VITE_ASSET__KrtHV1QY__"